import type React from 'react';
import { Button } from 'shared-portal-components-v2';

import type { EncryptionStepItem } from './FileUploadDialogV2.types';

interface FileUploadProgressViewProps {
  encryptionSteps: EncryptionStepItem[];
  uploadedFileCount: number;
  onDone: () => void;
}
export default function FileUploadProgressView({
  encryptionSteps,
  uploadedFileCount,
  onDone,
}: FileUploadProgressViewProps): React.JSX.Element {
  const isAllComplete =
    encryptionSteps.length > 0 &&
    encryptionSteps.every((step) => step.status === 'success');

  return (
    <div className="space-y-6">
      <div className="space-y-2 text-center">
        <h3 className="text-xl font-semibold">
          {isAllComplete ? 'Upload Complete!' : 'Uploading...'}
        </h3>
        <p className="text-sm text-muted-foreground">
          {uploadedFileCount} file(s) uploaded successfully
        </p>
      </div>
      <Button onClick={onDone} className="h-12 w-full">
        Done
      </Button>
    </div>
  );
}
